// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1cpva","header":"Messages_header__3Oh3H"};